module.exports = __webpack_public_path__ + "img/chord-label-F.d6717da7.png";